import React, { createContext, useEffect, useRef, useState} from "react";
import {
    accessTokenExpiresSoon,
    refreshAccessToken,
    restoreSession,
    sessionIdentity,
    signOut,
    subscribeAccessToken,
    tokenExpiryMs,
} from "services/cognitoAuth";


export const UserContext = createContext();

const REFRESH_BEFORE_EXPIRY_MS = 60 * 1000;

export const UserProvider = (props) => {

    const [token, setToken] = useState(undefined);
    const [id, setId] = useState("");
    const [email, setEmail] = useState("");
    const [role, setRole] = useState("");
    const hadSession = useRef(false);

    useEffect(() => {
        let cancelled = false;
        const unsubscribe = subscribeAccessToken((next) => {
            if (!cancelled) {
                setToken(next);
            }
        });
        refreshAccessToken().then((next) => {
            if (!cancelled) {
                setToken(next);
            }
        });
        return () => {
            cancelled = true;
            unsubscribe();
        };
    }, []);

    useEffect(() => {
        if (token === undefined) {
            return undefined;
        }
        if (!token) {
            if (hadSession.current) {
                hadSession.current = false;
                signOut();
            }
            setId("");
            setEmail("");
            setRole("");
            localStorage.removeItem("AuthorizationToken");
            return undefined;
        }

        let cancelled = false;
        hadSession.current = true;
        localStorage.setItem("AuthorizationToken", token);
        restoreSession().then((session) => {
            if (cancelled || !session) {
                return;
            }
            const identity = sessionIdentity(session);
            setId(identity.id);
            setEmail(identity.email);
            setRole(identity.role);
        });
        return () => {
            cancelled = true;
        };
    }, [token]);

    useEffect(() => {
        if (!token) {
            return undefined;
        }
        const expiresAt = tokenExpiryMs(token);
        const delay = Math.max(expiresAt - Date.now() - REFRESH_BEFORE_EXPIRY_MS, 5000);
        const timer = setTimeout(() => {
            refreshAccessToken();
        }, delay);
        return () => clearTimeout(timer);
    }, [token]);

    useEffect(() => {
        const refreshIfNeeded = () => {
            if (document.visibilityState !== "visible") {
                return;
            }
            if (accessTokenExpiresSoon(token)) {
                refreshAccessToken();
            }
        };
        document.addEventListener("visibilitychange", refreshIfNeeded);
        window.addEventListener("focus", refreshIfNeeded);
        return () => {
            document.removeEventListener("visibilitychange", refreshIfNeeded);
            window.removeEventListener("focus", refreshIfNeeded);
        };
    }, [token]);

    return (
        <UserContext.Provider value={[token, setToken, id, email, role]}>
            {props.children}
        </UserContext.Provider>
    )

};
